import { gql } from '@apollo/client';

const schema = {
  get: {
    name: 'region',
    serviceName: 'auth',
    query: gql`
      query region($ids: [String]) {
        region(ids: $ids) {
          data {
            area
            title
            shop {
              id
              title
            }
          }
        }
      }
    `,
  },
  update: {
    name: 'updateRegion',
    serviceName: 'shopadmin',
    query: gql`
      mutation updateRegion($ids: [String]!, $title: String!, $points: [String]!, $shop_id: String!) {
        updateRegion(ids: $ids, title: $title, points: $points, shop_id: $shop_id) {
          messages
        }
      }
    `,
  },
};

export default schema;
